import createModel from 'helpers/model';
import createApi from 'services/api';

const api = createApi({
  baseUrl: 'admin/goals',
  headers: {
    'Content-Type': 'application/json'
  },
});

const goalsSettingsModel = createModel({
  data: [],
  isLoading: false,
  error: null,
}, {
  setLoading(model, val) {
    model.actions.setState({
      ...model.state,
      isLoading: val,
    });
  },

  list(model) {
    model.actions.setLoading(true);

    return api.get('list')
      .then(data => {
        model.actions.setState({ ...model.state, data });
      })
      .catch(err => {
        model.actions.setState({ ...model.state, error: err });
      })
      .finally(() => {
        model.actions.setLoading(false);
      });
  },

  update(model, config) {
    return api.post('update', config);
  },
});

export default goalsSettingsModel;
